export const providers = Array.from({ length: 10 }).map(
  (_, index) => `/pay/${index + 1}.svg`,
);
